export default "__VITE_ASSET__JKmFpImX__"